import React from "react";
import cloud_migration_img from "../../assets/db_images/cloud-migration-bg.gif";
const Info = () => {
  return (
    <div id="about">
      <div className="flex p-5 flex-col sm:flex-row">
        <div className="w-full sm:w-[40%]">
          <img src={cloud_migration_img} />
        </div>
        <div className="w-full sm:w-[60%]">
          <p className="font-notosans mt-5 mb-10">
            To leverage innovative technologies, enterprises need faster access
            to data, seamless data integration, and highly scalable, flexible,
            and low-maintenance databases. Unfortunately, many enterprises
            continue to run legacy databases, which fail to meet these
            requirements. These organizations need to act fast and modernize
            their data and applications sooner rather than later to achieve –
          </p>
          <div className="flex justify-between sm:flex-row flex-col gap-3">
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Greater Agility
            </div>
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Optimized Cost
            </div>
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Reduced Risk
            </div>
            <div className="rounded-md p-10 border-2 font-notosans text-sm text-center">
              Improved Performance
            </div>
          </div>
          <p className="font-notosans mt-5">
            <span className="font-bold">
              Our organization offers a strategic approach to plan a database
              migration with minimal impact on systems and business operations.
            </span>
            &nbsp;With extensive experience across various technologies, our
            integrated methodology, and a skilled team, we assist organizations
            in defining their digital transformation roadmap. Our focus is on
            enabling faster innovation, improving customer experiences, and
            enhancing overall business process efficiency.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Info;
